import React, { Component } from 'react';
import $ from 'jquery';
import { findDOMNode } from 'react-dom';

export default class ForceOfOne extends Component {

toggle = () => {
    let toggle = findDOMNode(this.refs.toggle);
    $(toggle).toggle();
}

	render() {
		return (
			<div>
                <iframe id="video" ref="toggle" src="https://www.youtube.com/embed/1nJrBv2okIg" 
                title="Force of One"></iframe>
				<button
					type="button"
					className="btn forceOfOne"
					onClick={this.toggle}
				>
					Force of One
				</button>
			</div>
		);
	}
}